// extracted by mini-css-extract-plugin
module.exports = {"input":"_93444fe79c--input--UfYm3","tag":"_93444fe79c--tag--aiLXX"};